<div class="modal-header">
    <ion-grid class="ion-no-padding">
        <ion-row class="ion-no-padding">
            <ion-col size="10"
                     class="ion-no-padding">
                {{ 'FEED' | translate }}
            </ion-col>
            <ion-col size="2"
                     class="ion-no-padding ion-text-right">
                <a (click)="close()">
                    <svg-icon [applyClass]="true"
                              src="/assets/icons/ico-close.svg"
                              class="icon fill-dark"></svg-icon>
                </a>
            </ion-col>
        </ion-row>
    </ion-grid>
</div>

<div class="content-centered-column">
    <ng-container *ngIf="plt.isConnected && user && user.header_notifications">
        <ng-container *ngFor="let notification of user.header_notifications">
            <div class="invitation"
                 *ngIf="notification.data.type == 'invitation'">
                <p>{{ "HEADER_NOTIFICATIONS_NEW_INVITATION_TEXT" | translate: {'name': notification.data.event_name, 'date': notification.data.event_starts_at |
                    datex:'dateTimeFormatDefault':null:true} }}</p>
                <ion-button (click)="feedAccept(notification);">
                    {{ 'BUTTON_ACCEPT' | translate}}
                </ion-button>
                <ion-button class="btn-close"
                            (click)="feedDecline(notification);">
                    {{ 'BUTTON_DECLINE' | translate}}
                </ion-button>
            </div>
            <div *ngIf="notification.data.type == 'invitation-to-community'"
                 class="invitation">
                <p>{{ "REGISTRATION_LABEL_TRANSFER_ACCEPTED" | translate:{'eventName': notification.data.eventName} }}</p>
                <ion-button (click)="feedAccept(notification);">
                    {{ 'BUTTON_ACCEPT' | translate}}
                </ion-button>
                <ion-button class="btn-close"
                            (click)="feedDecline(notification);">
                    {{ 'BUTTON_DECLINE' | translate}}
                </ion-button>
            </div>
        </ng-container>
    </ng-container>
</div>